"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const date_fns_1 = require("date-fns");
const lodash_1 = require("lodash");
const react_1 = require("react");
const config_1 = require("config");
const merchant_management_v1_api_1 = require("merchant-management-v1-api");
const utils_1 = require("utils");
const useActivityTable = ({ locationId, currentPermissions, applicationStatus, }) => {
    // Vars
    const isActivityTableAccessible = (0, utils_1.operationPermitted)(currentPermissions, config_1.PERMISSION.APPLICATION_ACTIVITY_TABLE);
    const [postApplicationsReports, { data: applicationReports, isError: applicationReportError },] = (0, merchant_management_v1_api_1.usePostMerchantManagementV1ReportsApplicationsMutation)({
        fixedCacheKey: 'applicationsReport',
    });
    // Dates
    const todaysDate = new Date();
    const startDate = (0, date_fns_1.subDays)(todaysDate, config_1.REPORTS_START_OFFSET_DAYS);
    const endDate = new Date();
    endDate.setDate(todaysDate.getDate() + 1);
    const applications = (0, react_1.useMemo)(() => {
        if ((0, lodash_1.isEmpty)(applicationStatus))
            return [];
        const filteredData = applicationStatus.includes('All')
            ? applicationReports?.applications
            : applicationReports?.applications?.filter((application) => applicationStatus.includes(application.applicationStatus));
        const dataWithDisplayAmount = filteredData?.map((application) => {
            return {
                ...application,
                displayAmount: application.creditLimit,
                // ? application.creditLimit
                // : application.requestedAmount,
                // re: MC-1191: uncomment the above two lines when API is fixed
            };
        });
        return dataWithDisplayAmount?.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
    }, [applicationStatus, applicationReports]);
    const fetchApplications = (values = {
        startDate: undefined,
        endDate: undefined,
    }) => {
        const reportCriteria = {
            startDate: (0, date_fns_1.format)(values.startDate || startDate, 'yyyy-MM-dd'),
            endDate: (0, date_fns_1.format)(values.endDate || endDate, 'yyyy-MM-dd'),
        };
        const data = {
            postMerchantManagementV1ReportsApplications: {
                ...reportCriteria,
                locationIds: [locationId],
            },
        };
        postApplicationsReports(data);
    };
    const handleActivityFilter = (values) => {
        const tmpStartDate = values.startDate || startDate;
        const tmpEndDate = values.endDate || endDate;
        const isDateRangeInvalid = (0, date_fns_1.isAfter)(tmpStartDate, tmpEndDate);
        // Check Date Range
        if (isDateRangeInvalid) {
            (0, utils_1.toastError)('INVALID DATE RANGE! Start Date is after End Date.', 3000);
            return;
        }
        const reportCriteria = {
            startDate: (0, date_fns_1.format)(tmpStartDate, 'yyyy-MM-dd'),
            endDate: (0, date_fns_1.format)(tmpEndDate, 'yyyy-MM-dd'),
        };
        postApplicationsReports({
            postMerchantManagementV1ReportsApplications: {
                ...reportCriteria,
                locationIds: [locationId],
            },
        });
    };
    (0, react_1.useEffect)(() => {
        fetchApplications();
    }, [locationId]);
    return {
        isActivityTableAccessible,
        fetchApplications,
        handleActivityFilter,
        startDate,
        endDate,
        applicationReports,
        applicationReportError,
        applications,
    };
};
exports.default = useActivityTable;
